import { useCallback } from 'react';

import { EventCardPoint3 } from '@vlabs/monokit/shared/ui/event-card';
import { useHasPermission } from '@vlabs/permissions';

import { artemySearchApi } from './api/artemy';
import { SearchApiProvider } from './api/SearchApiProvider';
import { EventPreviewPoint3 } from './ui/reference-selector/reference-preview/event-preview/EventPreviewPoint3';
import { SearchProvider } from './ui/search-provider/SearchProvider';
import { SearchPageView } from './ui/SearchPageView';

const INCLUDED_ATTRIBUTES = [
  'gender', 'age', 'temperature', 'liveness', 'deepfake',
  'apparentGender', 'apparentAge', 'upperBody', 'lowerBody', 'headwear', 'backpack',
];

type TCan = (permissions: string[], params?: Record<string, string>) => boolean;

function SearchPagePoint3(): JSX.Element {
  const canEventMatching = useHasPermission('event_fs', 'read');
  const canFaceMatching = useHasPermission('card', 'read');

  const can: TCan = useCallback((permissionList, params) => {
    const checks = permissionList.map((permission) => {
      switch (permission) {
        case 'event:matching':
        case 'event:view':
          return canEventMatching;
        case 'face:matching':
          return canFaceMatching;
        // ponytail: в point3 нет концепции sdk-прав — дескрипторный поиск разрешён всем
        case 'resources:sdk':
          return true;
        default:
          return false;
      }
    });

    if (params?.method === 'allof') return checks.every(Boolean);
    return checks.some(Boolean);
  }, [canEventMatching, canFaceMatching]);

  return (
    <SearchApiProvider api={artemySearchApi}>
      <SearchProvider>
        <SearchPageView
          can={can}
          eventCard={EventCardPoint3}
          eventPreview={EventPreviewPoint3}
          includedAttributes={INCLUDED_ATTRIBUTES}
        />
      </SearchProvider>
    </SearchApiProvider>
  );
}

export { SearchPagePoint3 };
